<template>
  <Notifications />
  <router-view />
</template>


<script lang="ts">
import { UniqueComponentId } from "@ekkosense/client-framework"
import { Component, Vue } from "vue-facing-decorator"
import { ApplicationOptions } from "./core/helpers/ApplicationOptions"
import { DevelopmentFeature } from "./core/helpers"
import { ComponentPublicInstance } from "vue"

@Component({})
export default class App extends Vue {
  public api: any

  // Hooks

  async mounted() {
    const options = await ApplicationOptions.getConfig()
    if(!options?.inDevelopment) {
      UniqueComponentId.runtimeOptions.enabled = false
    }
    DevelopmentFeature.runtimeEnabled = options?.inDevelopment ?? false
  }

  // see https://vuejs.org/api/options-lifecycle.html#errorcaptured
  errorCaptured(err: unknown, instance: ComponentPublicInstance | null, info: string): boolean | void {
    console.error(err)
    this.$notifyError("An unknown error occurred")
    return true
  }
}
</script>
